import { HttpFailedToFetchException } from "../model/httpException";
import { ProjectShort } from "../model/projectShort";
import { getAuthHeaders } from "../utils/authHeaders";
import { logException } from "../utils/logUtils";

export class ProjectsApi {
  private static readonly BASE_URL = import.meta.env.VITE_API_URL;

  static async getProjectsForUser(): Promise<ProjectShort[]> {
    try {
      const headers = await getAuthHeaders({});

      const response = await fetch(`${this.BASE_URL}/projects`, {
        method: "GET",
        headers,
      });

      if (!response.ok) {
        const errorText = await response.text();
        logException("Projects API error (/projects):", {
          status: response.status,
          statusText: response.statusText,
          body: errorText,
        });
        throw new HttpFailedToFetchException();
      }

      const data = await response.json();
      return data.projects;
    } catch (error) {
      throw new HttpFailedToFetchException();
    }
  }
}
